<template>
  <main v-if="isVisible" class="modal-wrapper relative z-50 modal-filter fixed inset-0 w-full h-screen flex mt-2 justify-center bg-semi-75 h-fit">
    <transition name="modal-fade">
      <div class="modal-overlay" @click="$emit('close-modal')">
        <div class="modal relative" @click.stop>
          <!-- <h6>Saved!</h6> -->
          <div @click="$emit('closeModal')" class="absolute right-0 pr-4 top-5 cursor-pointer" v-if="closeVisible">
            <x-icon size="1.5x"></x-icon>
          </div>
          <div class="bg-white">
            <!-- adding gif in Plagiarism warning from Peer Review page-->

            <div>
              <div v-if="popUpImage1 || popUpImage2" class="font-bold text-center mb-3 flex justify-center text-base sm:text-xl">
                <div><strong>Do you want to mark the submission Plagiarised?</strong></div>
              </div>
              <div v-if="popUpImage1" class="w-full">
                <img src="@/assets/images/plag_warning1.gif" class="block px-4 pb-2 mx-auto w-3/12" />
              </div>
              <div v-if="popUpImage2" class="w-full">
                <img src="@/assets/images/plag_warning2.gif" class="block px-4 pb-2 mx-auto w-2/5" />
              </div>
            </div>

            <div class="text-gray-500 px-4" v-html="message"></div>
            <div class="pb-4 pt-4 bg-white flex flex-col items-center">
              <button @click="applyReview(reReviewButtonLink)" v-if="reReviewButton" class="px-4 py-2 my-2 text-white shadow-md bg-background-secondary focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">
                Apply Re-Review
              </button>

              <button @click="$emit('Archive')" v-if="archiveButton" class="px-4 py-2 my-2 text-white shadow-md bg-background-secondary focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 mr-2">Yes</button>
              <button
                @click="$emit('closeModal')"
                v-if="closeVisible"
                style="background-color: grey"
                class="px-4 py-2 my-2 text-white shadow-md bg-background-secondary focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
              >
                Restart Solidify
              </button>
              <button @click="navigate(link)" v-if="linkButton" class="px-4 py-2 my-2 text-white shadow-md bg-background-secondary focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">{{ linkButton }}</button>
              <!-- <button class="py-2 px-4 bg-blue-900 text-white shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75">Helpmate</button> -->
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
// eslint-disable-next-line
import router from '@/router';

export default {
  components: { XIcon },
  name: 'Generic',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true,
    },
    message: {
      type: String,
      default: '',
      required: true,
    },
    closeVisible: {
      type: Boolean,
      default: false,
      required: false,
    },
    reReviewButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    archiveButton: {
      type: Boolean,
      default: false,
      required: false,
    },
    reReviewButtonLink: {
      type: String,
      default: '',
      required: false,
    },
    link: {
      type: String,
      default: '',
      required: false,
    },
    linkButton: {
      type: String,
      default: '',
      required: false,
    },
    popUpImage1: {
      type: Boolean,
      default: false,
      required: false,
    },
    popUpImage2: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup() {
    const applyReview = async (reReviewButtonLink) => {
      router.push({ path: '/solidify/rereview', query: { learner_task_id: reReviewButtonLink } });
    };
    const navigate = (link) => {
      window.location.href = link;
    };
    return { applyReview, navigate };
  },
};
</script>

<style lang="postcss">
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  background-color: #000000da;
}
.modal {
  text-align: center;
  background-color: white;
  height: 200px;
  width: 600px;
  margin-top: 10%;
  padding: 40px 0;
  /* border-radius: 20px; */
}
p {
  /* font-weight: 500; */
  font-size: 16px;
  margin: 20px 0;
}
/* button {
  background-color: #ac003e;
  width: 150px;
  height: 40px;
  color: white;
  font-size: 14px;
  border-radius: 16px;
  margin-top: 50px;
} */
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.5s ease;
}
</style>
